import React, { useState,useCallback } from 'react';
import { Button } from 'react-bootstrap';
import FileDatatable from './FileDatatable';
import FileModal from './FileModal';



const FileTab = (props) => {

    
    const [show , setShow]= useState( false ); 
    const [recordId, setRecordId ] = useState( "" );
    
    const dialogRef = React.createRef();
  

    const handleCallback = useCallback(
      (id) => {
          setRecordId(id);       
          setShow(true);   
      },
      [], 
    );
 
    const modalCallback = (isShow) => {             
      setShow(isShow);              
    }


  

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
          <FileDatatable            
            parentCallback={handleCallback}
            entityId={props.entityId}
            entityName="file"           
            ref={dialogRef}    
            modalShow={show}                  
          />
          <FileModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}
            entityId={props.entityId}
            entityName="file"
            ref={dialogRef}
          />
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} //current => !current
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default FileTab;